import { Component } from '@angular/core';
import { SiteInfoService } from 'src/app/core/site-info.service';
import { LanguageService } from 'src/app/core/language.service';

@Component({
  selector: 'app-header2',
  templateUrl: './header2.component.html',
  styleUrls: ['./header2.component.css']
})
export class Header2Component {
  constructor(public info: SiteInfoService, public lang: LanguageService) {}
}
